import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback, useEffect } from 'react';
import { SocialButton, SocialDivider, SocialList, ProviderName } from './Social.styles';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { View } from '../../store/types';
import config from '../../config';
import { popupWindow } from '../../utils/popupWindow';
import { setGenericError } from '../../store/sharedActions';
import { sdkSsoLogin } from '../../store/reducers/sdkSsoLogin';
import { interactionsRioEvent, notificationsRioEvent } from '../../lib/rio/rioEvents';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
import getProviderIcon from './getProviderIcon';
import { getTexts } from '../../lib/contentful/defaultTexts';
var Social = function Social(_ref) {
  var providers = _ref.providers;
  var dispatch = useAppDispatch();
  var env = useAppSelector(function (state) {
    return state.env;
  });
  var socialUrl = config[env].oneAuthSocial;
  var showBack = useAppSelector(function (state) {
    return state.showBack;
  });
  var frontView = useAppSelector(function (state) {
    return state.frontView;
  });
  var backView = useAppSelector(function (state) {
    return state.backView;
  });
  var ssoError = useAppSelector(function (state) {
    return state.sso.error;
  });
  var authProvider = useAppSelector(function (state) {
    return state.sso.authProvider;
  });
  var currentView = showBack && backView || frontView;
  var _getTexts = getTexts(),
    _getTexts$signup = _getTexts.signup,
    genericError = _getTexts$signup.genericError,
    OrText = _getTexts$signup.OrText;
  var onMessage = useCallback(function (e) {
    var messageData = decodeMessage(e.data);
    var messageOrigin = e.origin;
    var messageTarget = e.target.origin;
    var urlFragments = new URL(socialUrl);
    var authProvider = messageData.authProvider,
      authProviderToken = messageData.authProviderToken,
      email = messageData.email,
      error = messageData.error,
      firstName = messageData.firstName,
      lastName = messageData.lastName;
    var isValid = authProvider && authProviderToken && email;
    if (messageTarget != window.location.origin || urlFragments.origin != messageOrigin) {
      return;
    }
    recordEvents(_defineProperty({}, EventTypes.messageReceived, {
      authType: authProvider,
      hasError: !!error
    }));
    if (error) {
      recordEvents(_defineProperty({}, EventTypes.oneAuthSocialLoginFail, {
        error: error,
        authType: authProvider
      }));
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'sign in error',
          message_detail: '',
          message_id: "Bff error: ".concat(error)
        }
      });
      return;
    }
    if (isValid) {
      dispatch(sdkSsoLogin({
        provider: authProvider,
        token: authProviderToken,
        email: email,
        firstName: firstName,
        lastName: lastName
      }));
    } else {
      recordEvents(_defineProperty({}, EventTypes.ssoLoginFail, {
        error: error,
        email: email
      }));
      dispatch(setGenericError({
        error: genericError
      }));
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'sign in error',
          message_detail: genericError,
          message_id: 'sign in: sso generic error'
        }
      });
      return;
    }
  }, [dispatch, genericError, socialUrl]);
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);
  var onSocialClick = useCallback(function (provider) {
    recordEvents(_defineProperty({}, EventTypes.socialClicked, {
      authType: provider
    }));
    popupWindow("".concat(socialUrl, "/").concat(provider, "?redirect=").concat(encodeURIComponent(window.location.origin)), 'Social Login to Chegg', 800, 600);
    interactionsRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'icon',
          name: 'social sign on',
          region_name: 'sign up auth page',
          value: provider
        }
      }
    });
  }, [socialUrl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SocialDivider, null, OrText), /*#__PURE__*/React.createElement(SocialList, {
    "data-test": "social",
    role: "group"
  }, renderIcons()));
  function renderIcons() {
    return providers.map(function (provider) {
      var showErrorBorder = ssoError && provider === authProvider && currentView === View.SIGNIN;
      var className = showErrorBorder ? 'error' : '';
      return /*#__PURE__*/React.createElement(SocialButton, {
        type: "button",
        key: provider,
        title: provider,
        "data-provider": provider,
        "data-test": "".concat(provider, "_button"),
        onClick: function onClick() {
          return onSocialClick(provider);
        },
        className: className
      }, getProviderIcon(provider), /*#__PURE__*/React.createElement(ProviderName, null, provider));
    });
  }
};
export default Social;

/* istanbul ignore next */
function decodeMessage(data) {
  var result = {};
  Object.keys(data).forEach(function (key) {
    if (typeof data[key] == 'string') {
      result[key] = decodeURIComponent(data[key]);
    } else {
      result[key] = data[key];
    }
  });
  return result;
}